import React, { useEffect, useState } from "react";

// components
import AlcoholCommonTable from "../../../components/alcohol/table/AlcoholCommonTable";
import AlcoholCommonPagination from "../../../components/alcohol/table/AlcoholCommonPagination";

// api
import { getUserLoginHistoryFromHearro } from "../../../services/apis/hearro/user";

const loginHistoryTableHeader = ['일시', '로그인 IP', '국가', '기기'];

const tableHeaderInfo = {
    일시: "insDate",
    "로그인 IP" : "ip",
    국가: "nation",
    기기: "device"
}


function HearroMyPageLoginHistory() {
    const [tableBody, setTableBody] = useState([]);

    const [totalPageCnt, setTotalPageCnt] = useState(1);
    const [curPage, setCurPage] = useState(1);

    const [inputSearchDate, setInputSearchDate] = useState({
        start: `${new Date().getFullYear()}-${(new Date().getMonth()+1).toString().padStart(2, '0')}-01`,
        end: `${new Date().getFullYear()}-${(new Date().getMonth()+1).toString().padStart(2, '0')}-${new Date().getDate().toString().padStart(2, '0')}`
    });
    const [searchDate, setSearchDate] = useState({
        // 당월의 1일
        start: `${new Date().getFullYear()}-${(new Date().getMonth()+1).toString().padStart(2, '0')}-01`,
        // 당일
        end: `${new Date().getFullYear()}-${(new Date().getMonth()+1).toString().padStart(2, '0')}-${new Date().getDate().toString().padStart(2, '0')}`
    });

    const handleChangePage = (page) => {
        setCurPage(page);
    }

    function handleSearch() {
        // 기간이 90일 이내인지 확인 및 start, end 날짜의 순서와 크기 확인
        const startDate = new Date(inputSearchDate.start);
        const endDate = new Date(inputSearchDate.end);
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if(startDate > endDate){
            alert("시작일이 종료일보다 늦을 수 없습니다.");
            return;
        }
        if(diffDays >= 90){
            alert("최대 90일 이내의 기간만 조회할 수 있습니다.");
            return;
        }
        setSearchDate({ start: inputSearchDate.start, end: inputSearchDate.end });
    }

    // YYYYMMDDHH24MISS 형태 (20240403100103)의 날짜 데이터를 받아 YYYY-MM-DD(Day) HH:MI 형태로 변환
    function convertDateString(dateString) {
        const dayList = ['일', '월', '화', '수', '목', '금', '토'];
        const YYYYMMDD = `${dateString.slice(0,4)}-${dateString.slice(4,6)}-${dateString.slice(6,8)}`;
        const dayIdx = new Date(YYYYMMDD).getDay();

        return `${YYYYMMDD}(${dayList[dayIdx]}) ${dateString.slice(8,10)}:${dateString.slice(10,12)}`
    }

    async function getLoginHistoryFromAPI() {
        if(!searchDate.start || !searchDate.end){
            alert("기간을 선택해주세요.");
            return;
        }

        try{
            // YYYYMMDD 형태로 변환
            const startDate = `${searchDate.start.split("-")[0]}${searchDate.start.split("-")[1]}${searchDate.start.split("-")[2]}`;
            const endDate = `${searchDate.end.split("-")[0]}${searchDate.end.split("-")[1]}${searchDate.end.split("-")[2]}`;

            const request = {
                start: startDate,
                end: endDate,
                page: curPage
            }

            const res = await getUserLoginHistoryFromHearro(request);
            if(parseInt(res.status/200,10)===1){
                if(res.data.length>0){                    
                    
                    const newData = res.data.map(e=>{
                        let device = "";
                        if(e.device){
                            device = e[tableHeaderInfo["기기"]].toLowerCase().includes('mobile') ? "Mobile(모바일)" : "PC(웹)";
                        }
                        
                        return {
                            일시: e.insDate ? convertDateString(e.insDate) : "",
                            "로그인 IP": e.ip || "",
                            국가: e.nation || "",
                            기기: device
                        }
                    })
                    setTableBody(newData);
                    if(res.data[0].totalCnt){
                        setTotalPageCnt(Math.ceil(res.data[0].totalCnt/10));
                    }
                }else{
                    setTableBody([]);
                    setTotalPageCnt(1);
                }                
            }
        }catch(err){
            console.error(err);
        }        
    }

    useEffect(()=>{
        getLoginHistoryFromAPI();
    },[searchDate, curPage])

    
    return (
        <div className="dashboardContent">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지 {">"} 로그인 기록</span>
			</div>
            <div className="mypage_login_history_wrapper">
                <div className="title">로그인 기록</div>
                <div className="description">최근 90일까지의 기록을 최대 1,000 건 까지 제공합니다.</div>
                <div className="table_wrapper">
                    <div className="table_search_row">
                        <input
                            type="date"
                            value={inputSearchDate.start}
                            onChange={e=>setInputSearchDate({
                                ...inputSearchDate,
                                start: e.target.value
                            })}
                        />
                        <p className="date_bar">ㅡ</p>
                        <input
                            type="date"
                            value={inputSearchDate.end}
                            onChange={e=>setInputSearchDate({
                                ...inputSearchDate,
                                end: e.target.value
                            })}
                        />
                        <button
                            className="message_search_button"
                            type="button"
                            onClick={handleSearch}
                        >조회</button>
                    </div>
                    <AlcoholCommonTable
                        type="login_history"
                        tableHeader={loginHistoryTableHeader}
                        tableBody={tableBody}
                    />
                    <AlcoholCommonPagination
                        pageCnt={totalPageCnt}
                        selectedPage={curPage}
                        SetSelectedPage={handleChangePage}
                    />
                </div>
            </div>
        </div>
    );
}

export default HearroMyPageLoginHistory;